import React from "react";
import Skeleton from "react-loading-skeleton";

const ReportManagementTable = ({
  searchText,
  setSearchText,
  filteredReports,
  isLoading,
  errorMessage,
  deletingReportId,
  onEditReport,
  onDeleteReport,
}) => {
  const renderSkeletonRows = () =>
    Array.from({ length: 5 }).map((_, rowIndex) => (
      <tr key={`skeleton-row-${rowIndex}`}>
        {Array.from({ length: 8 }).map((__, colIndex) => (
          <td key={`skeleton-cell-${rowIndex}-${colIndex}`}>
            <Skeleton height={20} />
          </td>
        ))}
      </tr>
    ));

  const hasNoResults = !isLoading && !errorMessage && filteredReports.length === 0;

  return (
    <div className="container-fluid pb-4">
      <div className="rr-manageCard">
        <div className="rr-manageHeader">
          <div>
            <h5 className="mb-1">Report Management</h5>
            <p className="mb-0 text-muted">
              Review registered reports and manage core metadata.
            </p>
          </div>
          <input
            type="text"
            className="form-control rr-manageSearch"
            placeholder="Search by report, report id, or group id"
            value={searchText}
            onChange={(event) => setSearchText(event.target.value)}
          />
        </div>

        <div className="table-responsive mt-3">
          <table className="table rr-table mb-0 table-hover table-collapsed">
            <thead>
              <tr>
                <th>Report Name</th>
                <th>Report ID</th>
                <th>Group ID</th>
                <th>Dataset ID</th>
                <th>Created By</th>
                <th>Created At</th>
                <th>RLS</th>
                <th>Actions</th>
              </tr>
            </thead>
            <tbody>
              {isLoading ? (
                renderSkeletonRows()
              ) : errorMessage ? (
                <tr>
                  <td colSpan="8" className="text-center text-danger py-4">
                    Unable to load reports. {errorMessage}
                  </td>
                </tr>
              ) : hasNoResults ? (
                <tr>
                  <td colSpan="8" className="text-center text-muted py-4">
                    {searchText.trim()
                      ? "No matching reports found."
                      : "No reports available."}
                  </td>
                </tr>
              ) : (
                filteredReports.map((report) => (
                  <tr key={report.reportId || report.reportGuid}>
                    <td>{report.reportName}</td>
                    <td>{report.reportId}</td>
                    <td>{report.groupId}</td>
                    <td>{report.datasetId}</td>
                    <td>{report.createdBy}</td>
                    <td>{report.createdAt}</td>
                    <td>
                      <span
                        className={`rr-rlsBadge ${
                          report.rlsEnabled ? "enabled" : "disabled"
                        }`}
                      >
                        {report.rlsEnabled ? "Enabled" : "Disabled"}
                      </span>
                    </td>
                    <td className="rr-actionsCol">
                      <div className="rr-actionsWrap">
                        {/** Keep edit available only when no delete request is in progress. */}
                        <button
                          type="button"
                          className="btn rr-rowBtn"
                          disabled={Boolean(deletingReportId)}
                          onClick={() => onEditReport(report)}
                        >
                          Edit
                        </button>
                        <button
                          type="button"
                          className="btn rr-rowBtn rr-rowBtnDanger"
                          disabled={Boolean(deletingReportId)}
                          onClick={() => onDeleteReport(report)}
                        >
                          {String(deletingReportId) === String(report.reportId) ? (
                            <>
                              <span
                                className="spinner-border spinner-border-sm me-2"
                                role="status"
                                aria-hidden="true"
                              ></span>
                              Deleting...
                            </>
                          ) : (
                            "Delete"
                          )}
                        </button>
                      </div>
                    </td>
                  </tr>
                ))
              )}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
};

export default ReportManagementTable;
